import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ChatWidget } from "@/components/site/ChatWidget";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-[#F4F6F3]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:serviceId" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <ChatWidget />
        <Toaster position="top-right" theme="light" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
